import { isAppDesktopShellScreen } from "../helpers/appDesktopNav";
import { resolveTopLevelHubReturn } from "./hubReturnTarget";

/**
 * Discovery parents for the More / Finance information architecture.
 * A contextual screen id is preserved. The retired Command Center is not.
 */
const DISCOVERY_PARENTS = Object.freeze({
  more: "mode_select",
  finance: "finance_dashboard",
});

export function resolveIaReturnTarget(origin) {
  if (origin && Object.prototype.hasOwnProperty.call(DISCOVERY_PARENTS, origin)) {
    return DISCOVERY_PARENTS[origin];
  }
  return resolveTopLevelHubReturn(origin);
}

/**
 * Estimates Hub Back.
 * An explicit caller is preserved (Dashboard, More, Quick Create, pipeline).
 * A missing caller uses that entry path's fallback. Command Center is never
 * a return destination.
 */
export function resolveEstimateHubReturn(origin, fallback = "more") {
  const candidate =
    typeof origin === "string" && origin.length > 0 ? origin : fallback;
  return resolveIaReturnTarget(candidate);
}

/**
 * Where Settings returns. A real CrewPilot screen is kept. Command Center,
 * the Settings screen itself, and auth/legacy hubs become the Dashboard.
 */
export function settingsLeaveTarget(origin) {
  const resolved = resolveIaReturnTarget(origin);
  if (resolved === "settings") return "kpi_dashboard";
  if (isAppDesktopShellScreen(resolved)) return resolved;
  if (resolved === "mode_select" || resolved === "quick_create") return resolved;
  return "kpi_dashboard";
}
